import OfficesContent from "../../Component/Offices/OfficesContent";

function Offices() {
  return  <OfficesContent />
      
}

export default Offices;
